<ng-container *transloco="let t">
  <div class="card glass flex h-84 w-96 flex-col overflow-hidden">
    <figure class="h-1/4 overflow-hidden">
      <img [src]="image" alt="car!" class="h-full w-full object-cover" />
    </figure>
    <div class="card-body grow overflow-auto">
      <button
        (click)="editInformationCard()"
        class="btn btn-circle btn-sm absolute top-2 right-2"
      >
        <svg
          class="h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>
      <button
        (click)="removeInformationCard()"
        class="btn btn-circle btn-neutral btn-sm absolute top-2 left-2"
      >
        <svg
          class="h-6 w-6"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <h2 class="card-title">{{ title }}</h2>
      <div class="markdown-container h-32 overflow-auto">
        <p
          class="markdown-preview prose line-clamp-1 max-w-full cursor-pointer"
        >
          <markdown [data]="content"> </markdown>
        </p>
      </div>
      <div class="card-actions justify-end">
        <button (click)="readMoreInformationCard()" class="btn btn-primary">
          {{ buttonTitle }}
        </button>
      </div>
      <div class="mt-4 text-sm text-neutral-400 italic">
        <p>{{ t('information-card-author') }} {{ author }}</p>
        <p>
          {{ t('information-card-published-on') }}
          {{ publishedDate | localeDate: 'mediumDate' }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
